import React from 'react';
import Label from 'components/form/Label/Label';
import { commafy } from 'helpers/number';
import { Row } from 'components/Containers/Row/Row';
import { Button } from 'components/form/Button';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import './StandardPersonalLoanOfferRedesign.scss';
import { Link } from 'components/navigation/Link/Link';

const PersonalLoanOfferDetails = props => {
  const { extraClass, offerMetadata, config } = props;
  return (
    <FlexContainer className={extraClass}>
      <Label
        type="Body-2"
        color="secondary_text_light"
        className={'text-18 m-text18 bold margt10'}
      >
        {offerMetadata?.name}
      </Label>
      <Label type="Body-2" className={'text-16 m-text-14 margtb10'}>
        Loan Amount:{' '}
        <span className="bold"> ${commafy(offerMetadata?.loanAmount)} </span>|
        Monthly Payment:{' '}
        <span className="bold">
          {' '}
          ${commafy(offerMetadata?.monthlyPayment)}{' '}
        </span>
        | Term: <span className="bold"> {offerMetadata?.termMonths} mo. </span>|
        APR: <span className="bold"> {offerMetadata?.apr}% </span>| Interest &
        Fees Est: <span className="bold"> ${offerMetadata?.totalCost} </span>
      </Label>
      <Label type="Body-2" className={'fontGray500 text-14 m-text-12'}>
        Apply Now on {offerMetadata?.name}'s {config?.secureWebsiteDisclaimer}
      </Label>
    </FlexContainer>
  );
};

const StandardPersonalLoanOfferRedesign = props => {
  const { offerMetadata, offerImageLinkUrlProxy, seenPixel } = props;
  return (
    <FlexContainer
      className={
        'flex-container personalLoanOffer grayShadow16 margt12 border-rad8px padT40 padB48 bgWhite'
      }
    >
      {seenPixel}
      <Row className={'format100'}>
        <FlexContainer className={'flex-column'}>
          <FlexContainer className={'justify-between format100'}>
            <FlexContainer className={'m-flex-column'}>
              <img
                alt="personal loan"
                src={offerImageLinkUrlProxy}
                className="pointer imgCardSize align-self-center"
              />
              <PersonalLoanOfferDetails
                extraClass={'flex-column m-hide marglr40 marglr20'}
                offerMetadata={offerMetadata}
                config={props?.config}
              />
            </FlexContainer>
            <FlexContainer className={'flex-column align-self-center margt10'}>
              <Button
                mrphType="primary"
                onClick={props.clickApplyHandler}
                className="border-rad100px"
              >
                <Label
                  type="Subtitle-2"
                  color="primary_cta_text_light"
                  className={'text-16 m-text-14 marglr20 m-marglr10'}
                  tabIndex="-1"
                >
                  {'Apply for Offer'}
                </Label>
              </Button>
              <Link
                className={'align-self-center pointer'}
                ariaLabel="View Details"
                onClickCallback={props.clickDetailsHandler}
              >
                <Label
                  type="Subtitle-2"
                  color="secondary_text_light"
                  className={
                    'text-16 m-text-14 margt10 align-self-center pointer'
                  }
                  tabIndex="-1"
                >
                  {'View Details'}
                </Label>
              </Link>
            </FlexContainer>
          </FlexContainer>
          <PersonalLoanOfferDetails
            extraClass={'flex-column d-hide'}
            offerMetadata={offerMetadata}
            config={props?.config}
          />
        </FlexContainer>
      </Row>
    </FlexContainer>
  );
};

export { StandardPersonalLoanOfferRedesign };
